import React from 'react'

/**
 * TelephonySettingsHeader Component
 * Canonical Top Canopy matching the Attendance module design language.
 * Displays module eyebrow, 3xl bold title, configuration summary, and live CPaaS connectivity status.
 */
export default function TelephonySettingsHeader() {
  return (
    <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
          Telephony Configuration
        </p>
        <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
          Cloud Telephony Settings &amp; Agent Provisioning
        </h1>
        <p className="mt-0.5 text-xs text-on-surface-variant font-medium">
          Configure Exotel CPaaS multi-app credentials and provision Bridge employees as WebRTC softphone SIP agents.
        </p>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest px-4 py-2 shadow-xs">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          <span className="text-xs font-bold text-emerald-800">
            Exotel CPaaS: Multi-App Active
          </span>
        </div>
      </div>
    </section>
  )
}
